import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Breadcrumbs from '../../../layout/breadcrumbs';
import AdminSidebar from '../../../layout/admin-sidebar';
import DeletePaymentMethod from './delete';
import Spinner from '../../../shared/spinner';
import {handleServerError} from '../../../../helpers';
import {
  useDeletePaymentMethodMutation, useFetchPaymentMethodsQuery
} from '../../../../services';
import { PaymentMethod } from '../../../../interfaces';
import { toast } from 'react-toastify';

const PaymentMethods = () => {
  const [paymentMethods, setPaymentMethods] = useState<PaymentMethod[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [paymentMethodID, setPaymentMethodID] = useState<string>('');
  const [showDeleteModal, setShowDeleteModal]
    = useState<boolean>(false);

  const {
    data,
    isLoading,
    isError,
    isSuccess,
    error,
    refetch,
  } = useFetchPaymentMethodsQuery({});

  const [remove, { isLoading: isDeleting }] = useDeletePaymentMethodMutation();

  useEffect(() => {
    if (isError) {
      handleServerError(error);
    }
    if (isSuccess && data) {
      setPaymentMethods(data);
    }
  }, [isError, isSuccess]);

  useEffect(() => {
    setLoading(isLoading || isDeleting);
  }, [isLoading, isDeleting]);

  const deletePaymentMethod = (id: string) => {
    remove(id)
      .unwrap()
      .then(() => {
        toast.success('Payment Method deleted');
        return refetch();
      })
      .catch(handleServerError);
  }

  return (
    <div id="page-content">
      <Breadcrumbs crumbs={[
        { page: 'Account', link: '/admin/profile' },
        { page: 'PaymentMethods' }
      ]}/>

      <div className="container">
        <div className="row">
          <div className="col-md-3 col-sm-2">
            <AdminSidebar/>
          </div>
          <div className="col-md-9 col-sm-10">
            <section id="paymentMethods">
              <header>
                <h1 style={{ display: "flex", justifyContent: "space-between" }}>
                  <span>Payment Methods</span>
                  <Link to={'/admin/payment/methods/add'} className={"btn btn-default"}>
                    <i className={"fa fa-plus"}/> Create New PaymentMethod
                  </Link>
                </h1>
              </header>
              <div className="my-paymentMethods">
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                    <tr>
                      <th>Name</th>
                      <th>Currency</th>
                      <th>Type</th>
                      <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                      {loading && (
                        <tr>
                          <td colSpan={5}>
                            <Spinner text={'Fetching payment methods...'}
                                     style={{ padding: '50px' }}/>
                          </td>
                        </tr>
                      )}
                      {isError && (
                        <tr>
                          <td colSpan={5}>
                            <div className={"center"} style={{ padding: '50px' }}>
                              Failed to fetch payment methods
                            </div>
                          </td>
                        </tr>
                      )}
                      {isSuccess && paymentMethods.length === 0 && (
                        <tr>
                          <td colSpan={5}>
                            <div className={"center"} style={{ padding: '50px' }}>
                              No payment method found
                            </div>
                          </td>
                        </tr>
                      )}
                      {isSuccess && paymentMethods.length > 0 &&
                        paymentMethods.map((paymentMethod, i) => (
                        <tr key={i}>
                          <td>{paymentMethod.name}</td>
                          <td>{paymentMethod.currency}</td>
                          <td>{paymentMethod.type}</td>
                          <td>
                            <div className="actions">
                              <Link to={'/admin/payment/methods/edit/' + paymentMethod.id}
                                    className="edit mr-1">
                                <i className="text-default fa fa-pencil"/>
                              </Link>
                              <Link to="#" onClick={() => {
                                setPaymentMethodID(paymentMethod.id);
                                setShowDeleteModal(true);
                              }}>
                                <i className="text-danger fa fa-trash-o"/>
                              </Link>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>

      <DeletePaymentMethod id={paymentMethodID} isModalVisible={showDeleteModal}
                      handleCancel={() => setShowDeleteModal(false)}
                      deletePaymentMethod={deletePaymentMethod}/>
    </div>
  );
}

export default PaymentMethods;